import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { KendoModule } from '@shared/kendo/kendo.module';
import { FormField } from '@shared/models/formfield';
import { fieldsToForm } from '@utils/utils';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';

@Component({
  selector: 'app-form-grid',
  standalone: true,
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss'],
  imports: [
    ReactiveFormsModule,
    KendoModule,
    CommonModule,
    AutocompleteComponent,
    TranslateModule,
  ],
})
export class FormGridComponent implements OnInit {
  @Input() public form!: FormGroup;
  @Input() fields: FormField[] = [];
  @Input() rows: string[] = ['1fr', '1fr'];
  @Input() cols: string[] = ['1fr', '1fr'];
  @Input() initialValues = {};
  @Input() styles: any;

  @Output() submit = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() formRef = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.form = fieldsToForm(this.fields, this.initialValues);
    console.log(this.form)
    this.formRef.emit(this.form);
  }

  onSubmit() {
    this.submit.emit(this.form.value);
  }

  onCancel() {
    this.cancel.emit();
  }
}
